<template>
    <div>.</div>
</template>

<script>

    import AuthorizationRepository from "../../repositories/authorization.repository";

    export default {
        components: {
            AuthorizationRepository
        },
        created() {
            localStorage.setItem('signedIn', false);
            localStorage.setItem('signInExpiresAt', 0);
            this.$emit('reset-loading-pop-up');
            this.$emit('authChanged');
            this.$router.push({
                name: 'sign-in',
                params: {'currentroute': this.$route.params.currentroute}
            });
            AuthorizationRepository.logout();
        }
    }
</script>
